module.exports = __webpack_public_path__ + "static/media/fontello.e76efb5c.ttf";